// @ts-nocheck
import cx from 'js/lib/helpers/cx'

import styles from './Wrapper.module.css'

const Wrapper = ({ as, checked, className, children, ...rest }) => {
    const Tag = as || 'div'

    return (
        <Tag
            className={cx(styles.wrapper, className)}
            data-checked={checked ? 'true' : undefined}
            {...rest}
        >
            {children}
        </Tag>
    )
}

export default Wrapper
